import {Subject} from 'rxjs';
import ReconnectingWebSocket from 'reconnecting-websocket'
import {roomStore} from "./room";

export type GlobalState = {
  loading: boolean
  toast: {
    type: string
    message: string
  }
  dialog: {
    type: string
    message: string
    confirmText?: string
    cancelText?: string
  }
  uploadNotice: {
    type: string
    title: string
  },
  notice: {
    text: string
    reason: string
  },
  nativeWindowInfo: {
    visible: boolean
    items: any[]
  },
  io: any,
  mySocket: {
    message: any
  }
}

export class Root {
  private subject: Subject<GlobalState> | null;
  public state: GlobalState;
  public readonly defaultState: GlobalState = {
    loading: false,
    toast: {
      type: '',
      message: '',
    },
    dialog: {
      type: '',
      message: '',
      confirmText: '确定',
      cancelText: '取消'
    },
    uploadNotice: {
      type: '',
      title: '',
    },
    notice: {
      reason: '',
      text: '',
    },
    nativeWindowInfo: {
      visible: false,
      items: []
    },
    io: new ReconnectingWebSocket('wss://im.sys.sumfen.com/wss', [], {
      connectionTimeout: 20000,
      maxRetries: 10,
    }),
    mySocket: {
      message: ''
    }
  }

  constructor() {
    this.subject = null;
    this.state = this.defaultState;
  }

  initialize() {
    this.subject = new Subject<GlobalState>();
    this.state = {
      ...this.defaultState,
    }
    this.subject.next(this.state);
    const rws = this.state.io;
    rws.addEventListener('open', async (scoket: any) => {
      if (rws.readyState === 1) {
        // 这个是你给websocket 传输它要的东西
        console.log('websocket链接成功')
      } else {
        console.log(rws.readyState)
      }
    })
    rws.addEventListener("message",async (e: any) => {
      if (e.data) {
        let result = JSON.parse(e.data);
        switch (result.type) {
          case 'init':
            break;
          case 'ping':
            // 心跳检测
            rws.send('{"type":"pong"}')
            break;
          case 'join':
            // 绑定直播间
            break;
          case 'message':
            // 接收消息
            break;
          case 'pc_live':
            // 扫码成功
            break;
        }
        this.state = {
          ...this.state,
          mySocket: {
            message: result
          }
        }
        this.commit(this.state);
      }
    });

    // 错误时进行的处理
    rws.addEventListener("error", (e: any) => {
      console.error(e.message);
    });
    // 关闭时进行的操作
    rws.addEventListener("close", () => {
      this.showLoading()
      window.location.reload()
      console.info("asset service disconnected.");
    });
  }

  subscribe(updateState: any) {
    this.initialize();
    this.subject && this.subject.subscribe(updateState);
  }

  unsubscribe() {
    this.subject && this.subject.unsubscribe();
    this.subject = null;
  }

  commit (state: GlobalState) {
    this.subject && this.subject.next(state);
  }

  renewWebsocket () {
    this.state = {
      ...this.state,
      io: new ReconnectingWebSocket('wss://im.sys.sumfen.com/wss', [], {
        connectionTimeout: 20000,
        maxRetries: 10,
      })
    }
    this.commit(this.state);
  }

  updateState(rootState: GlobalState) {
    this.state = {
      ...this.state,
      ...rootState,
    }
    this.commit(this.state);
  }

  showNotice({
    reason,
    text,
  }:{
    reason: string,
    text: string
  }) {
    this.state = {
      ...this.state,
      notice: {
        text,
        reason
      }
    }
    this.commit(this.state);
  }

  removeNotice() {
    this.state = {
      ...this.state,
      notice: {
        text: '',
        reason: ''
      }
    }
    this.commit(this.state);
  }

  setNativeWindowInfo({visible, items}: {visible: boolean, items: any[]}) {
    this.state = {
      ...this.state,
      nativeWindowInfo: {
        visible,
        items
      }
    }
    this.commit(this.state);
  }

  showUploadNotice({type, title}: {type: string, title: string}) {
    this.state = {
      ...this.state,
      uploadNotice: {
        type,
        title
      }
    }
    this.commit(this.state);
  }

  removeUploadNotice() {
    this.state = {
      ...this.state,
      uploadNotice: {
        type: '',
        title: ''
      }
    }
    this.commit(this.state);
  }

  showToast({type, message}: {type: string, message: string}) {
    this.state = {
      ...this.state,
      toast: {
        type, message
      },
    }
    this.commit(this.state);
  }

  showDialog({type, message}: {type: string, message: string}) {
    this.state = {
      ...this.state,
      dialog: {
        type,
        message
      },
    }
    this.commit(this.state);
  }

  removeDialog() {
    this.state = {
      ...this.state,
      dialog: {
        type: '',
        message: ''
      },
    }
    this.commit(this.state);
  }

  showLoading () {
    this.state = {
      ...this.state,
      loading: true
    }
    this.commit(this.state);
  }

  stopLoading () {
    this.state = {
      ...this.state,
      loading: false
    }
    this.commit(this.state);
  }
}

export const globalStore = new Root();
